<template>
    <div>
      <div class="one_1">
      <img src="../assets/HelloWorld/logo.png" alt="" class="helloLest" @click="tiaozhaun(0)"/>
      <img src="../assets//yidong//0.png" alt="" class="helloLest" @click="zhankai()" />
      <div v-if="zhankaiTop" @mousewheel="mousewheel" style="z-index: 2000; position: fixed;width: 100vw;height: 100vh;background-color: rgba(0,0,0,.7);top: 0;right: 0;" @click="zhankai()"></div>
      <div v-if="zhankaiTop" :class="['animate__animated',zhankaiTop ? 'animate__fadeInRight' : '']" @mousewheel="mousewheel" style="position: relative; padding: 10px 16px; z-index: 2010; position: fixed;top: 0;right: 0;width: 75%;height: 100%;background: #2e2e2e;">
        <div class="one_2" @click="tiaozhaun(0)">首页</div>
        <div class="one_2" @click="tiaozhaun(1)">解决方案</div>
        <div class="one_2" @click="tiaozhaun(2)">下载与支持</div>
        <div class="one_2" @click="tiaozhaun(3)">联系我们</div>
        <!-- <div class="one_2" @click="tiaozhaun(4)">
          <a href=“tel:13156740937” > 拨打电话</a>
        </div> -->
        <div style="position: absolute;bottom: 50px;left: 0px;width: 100%; color: #fff;display: flex;flex-direction: column;align-items: center;">
          <div class="one_3">专属知识培训平台</div>
          <el-link href="https://affim.baidu.com/unique_49847201/mobile/chat?siteId=19538945&userId=49847201&siteToken=d938ff4f7bae9254e1d97e1fae316cf6" target="_self" style="width: 100%;">  
            <div class="one_4">免费体验</div>  
          </el-link>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import BottomBossVue from "@/components/BottomBoss"
export default {
  name: "HomeView",
  components: {

  },
  data() {
    return {
      http: this.$getCookie('http'),
      TopUp: 0,
      dddddd: 0,
      screenWidth: 0, // 判断pc,yd
      zhankaiTop: false,
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
   
        if (val.path == '/') {
          this.dddddd = 1
          const cnzzScript = document.createElement('script');
          cnzzScript.type = 'text/javascript';
          cnzzScript.src = 'https://s4.cnzz.com/z_stat.php?id=1281288238';
          document.body.appendChild(cnzzScript);
        } else {
          this.dddddd = 0

        }
        // this.activeIndex = this.$getItem('tad')
      },
      // 深度观察监听
      deep: true


    },
    $router(to, from) {
    }

  },
  created() {
    // 获取渠道id
    // const urlParams = new URLSearchParams(window.location.search);
    // const t = urlParams.get('t');
    // if (t) {
    //   this.http = `${this.$baseUrl}/#/register?t=${t}`
    //   this.$setCookie('t', t)
    //   // Cookies.set('t',t)
    // } else if (this.$getCookie('t')) {
    //   this.http = `${this.$baseUrl}/#/register?t=${this.$getCookie('t')}`
    // } else {
    //   this.http = `${this.$baseUrl}/#/register`
    // }
    // const path = this.$route.path;
    // console.log(path);
    // if((path != '/schemeA') && (path != '/schemeB') && (path != '/schemeC')){
    //   this.$router.push('/')
    // }
  },
  mounted() {

    this.screenWidth = document.body.clientWidth
    window.addEventListener("scroll", this.handleScroll)
  },
  methods: {
    mousewheel(e) {
      console.log(e);
      e.preventDefault();
    },
    zhankai() {
      this.zhankaiTop = !this.zhankaiTop
      this.$removeCookie('yiDong')
    },
    tiaozhaun(i){
      window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      this.zhankaiTop=false
      if(i == 0){
        this.$router.push('/')
      }
      if(i == 1){
        this.$router.push('/schemeA')
      }
      if(i == 2){
        this.$router.push('/schemeB')
      }
      if(i == 3){
        this.$router.push('/schemeC')
      }
      if(i == 4){
        window._MEIQIA('showPanel');
      }
    }
  },
  // 清空
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll)
  },
}
</script>
<style lang="scss" scoped>

::v-deep .el-link--inner{
  width: 100%;
  display: flex;
    justify-content: center;
}
.one_1 {
  background: #ffffff;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}

.one_2 {
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #484848;
  line-height: 40px;
  color: #fff;
  font-size: 14px;
  padding: 8px 12px 2px;
}

.helloLest {
  // width: 84px;
  //  transform: translate3d(0,-50%,0);
  height: 20px;
}

.one_3 {
  line-height: 30px;
  font-size: 18px;

}

.one_4 {
  width: 75%;
  height: 46px;
  display: flex;
  font-size: 18px;
  justify-content: center;
  align-items: center;
  background: #eb5b05;
  color: #ffffff;
  margin-top: 10px;
}</style>